module.exports = __webpack_public_path__ + "static/media/btn_primaryschool_01_Generaltips.80fc7cdf.png";